import React, { useState, useContext, useMemo } from "react";
import BasicContext from '../BasicContext';
import { Picker, InputItem, List } from 'antd-mobile';

export default function ChannelFilter(props) {

  const { value, onChange, rangerName, filter, title } = props;

  const context = useContext(BasicContext);
  const allChannels = context.channels || [];

  const channels = useMemo(() =>
    filter && filter.Purpose ? allChannels.filter(item => item.Purpose === filter.Purpose) : allChannels,
    [filter, context]
  );

  const rangerItem = (item) => {
    return rangerName ? rangerName(item) : `${item.ChannelName}-${item.ChannelId}`
  }

  const getOptions = (channels) => {
    // 搜索的时候应该按照短信类型过滤
    let options = [];
    if (channels && channels.length > 0) {
      //格式化并去重
      channels.forEach(item => {
        if (!options.find(o => o.value === item.ChannelId)) {
          options.push({ label: rangerItem(item), value: item.ChannelId })
        }
      });
    }
    return options
  }

  const [channelOptions, setChannelOptions] = useState(getOptions(channels));

  const onSearchChange = (v) => {
    const filterAccount = channels.filter(item =>
      (((item.ChannelName + item.ChannelId) || '').toLocaleLowerCase()).indexOf((v || '').toLocaleLowerCase()) >= 0);
    const options = getOptions(filterAccount);
    setChannelOptions(options);

    // 理论上每搜索一下，再强制选中第一个
    if (options && options.length) {
      onChange([options[0].ChannelId]);
    }
  }

  return <Picker
    title={<InputItem
      placeholder="搜索通道"
      className="picker-search-input"
      style={{ width: "100%" }}
      clear={true}
      onChange={onSearchChange}
    />}
    itemStyle={{ fontSize: 12 }}
    data={channelOptions}
    value={value}
    onChange={v => onChange(v)}
    cols={1}
  >
    <List.Item className="channel-picker-list" arrow="horizontal">{title || '通道'}</List.Item>
  </Picker>
}
